import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { GrDocumentDownload } from "react-icons/gr";

export const ExportPDF = ({ tRef, fileName }) => {
  const handleExport = () => {
    const doc = new jsPDF("l");

    const tableElement = tRef?.current;

    if (!tableElement) {
      console.error("Table element not found");
      return;
    }

    const tableHeaders = Array.from(
      tableElement.querySelectorAll("thead th")
    ).slice(0, -1);
    const tableBody = tableElement.querySelectorAll("tbody tr");

    if (tableHeaders.length === 0 || tableBody.length === 0) {
      console.error("Table headers or body not found");
      return;
    }

    const columns = tableHeaders.map((th) => th.textContent);

    const data = Array.from(tableBody).map((tr) => {
      const cells = Array.from(tr.querySelectorAll("td")).slice(0, -1);
      return cells.map((td) => td.textContent);
    });

    if (columns.length === 0 || data.length === 0) {
      console.error("No columns or data found in the table");
      return;
    }

    autoTable(doc, {
      head: [columns],
      body: data,
      styles: {
        cellPadding: 5,
        fontSize: 10,
        valign: "middle",
        halign: "left",
      },
      headStyles: {
        fillColor: [241, 244, 208],
        textColor: [190, 198, 99],
      },
    });

    doc.save(`${fileName}.pdf`);
  };

  return (
    <button
      onClick={handleExport}
      className="tw-border tw-border-black/10 tw-rounded-full tw-bg-transparent tw-w-fit tw-h-auto tw-p-3 tw-grid tw-place-items-center hover:tw-bg-gray-100"
    >
      <GrDocumentDownload className="size-4" />
    </button>
  );
};
